import { useCheckAppsCompatibility } from "@app/api/checkAppsCompatibility"
import { useGetDwhSettingsByBridgeId } from "@app/api/getDwhSettingsByBridgeId"
import { useEffect, useState } from "react"

export const handleDwhRedirectUri = ({
    bridgeId,
    sourceId,
    destinationId,
}: {
    bridgeId?: string
    sourceId?: number
    destinationId?: number
}) => {
    const [dwhAvailable, setDwhAvailable] = useState<boolean>(false)

    const {
        data: appCompatibilityCheck,
        isLoading: isCheckingAppsCompatibility,
        error: apiError,
      } = useCheckAppsCompatibility(sourceId, destinationId)

    const {
        data: dwhSettings,
    } = useGetDwhSettingsByBridgeId(bridgeId)

    useEffect(() => {
        if (!isCheckingAppsCompatibility && appCompatibilityCheck) {
        const isAvailable =
            appCompatibilityCheck?.combination?.availableBridgeFeatures?.some(
            (feature) =>
                feature.moduleId === 'dwh' && feature.available
            )
        setDwhAvailable(isAvailable)
        }
    }, [appCompatibilityCheck])

    return {
        dwhAvailable,
        existingDwhId: dwhSettings?.data?.id,
        errorGettingDwh: apiError,
    }
}